import * as Yup from "yup";
const RoleValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Role ID is required."),
});

export { RoleValidationSchema };
